<ion-ahs-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-back-button mode="md" defaultHref="/menu/enrollment" id="script-action-back-btn"></ion-back-button>
		</ion-buttons>
		<ion-title class="toolbar-color">
			{{ translateTitle | translate }}
		</ion-title>
	</ion-toolbar>
</ion-ahs-header>

<ion-content>
	<ion-item class="ahs-ion-item-title" lines="none">
		<div class="ahs-ion-item-row-title">
			<div class="ahs-ion-item-icon">
				<fa-icon [icon]="instructionIcon"></fa-icon>
			</div>
			<div class="ahs-ion-item-content">
				<div class="ahs-ion-item-details">
					{{ translateInstructions | translate }}
				</div>
			</div>
		</div>
	</ion-item>

	<ahs-collector
		*ngIf="!loading && scriptId"
		[accountId]="accountId"
		[personSelectLabel]="personSelectLabel | translate"
		[personSelectFilter]="personSelectFilter"
		[usePersonSelect]="usePersonSelect"
		[showSinglePagePersonSelect]="showSinglePagePersonSelect"
		[definitionId]="scriptId"
		[showCancel]="true"
		(onFinished)="onFinished($event)"
		(onCancel)="onCancel($event)"
		[mode]="scriptMode"
		[linkedEntityId]="linkedEntityId"
		[linkedEntityNameId]="linkedEntityNameId"
		[(collectorArray)]="collectorArray"
		[personSelectApperanceOutline]="true"
		[customStyles]="'background-color:white;'"
	>
	</ahs-collector>
	<ng-template #displayNoEligibilityMessage>
		<div class="no-eligibility-container">
			<b
				><h2>{{ noEligibilityMessageTranslationKey | translate }}</h2></b
			>
		</div>
	</ng-template>
</ion-content>
